import { createStyles } from '@mantine/core';

var useStyles = createStyles((theme) => ({
  decadeLevel: {},
  calendarHeader: {
    marginBottom: theme.spacing.xs
  }
}));

export default useStyles;
//# sourceMappingURL=DecadeLevel.styles.js.map
